var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm._class,attrs:{"id":_vm.id,"tabindex":"-1","role":"dialog","aria-labelledby":_vm.id,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content o-hidden"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }